import type { MetaFunction } from "@remix-run/node";

import "../privacy.scss";

export const meta: MetaFunction = () => {
  return [{ title: "Tempt - Privacy Policy" }];
};

export default function PrivacyPolicy() {
  return (
    <section className="text-white pt-10 terms">
      <div className="container">
        <h1 className="page-title">Privacy Policy</h1>
        <span>Last Updated: April 01, 2025</span>
        <div className="page-body">
          <div>
            <p>
              This Privacy Policy applies to your use of&nbsp;
              <strong>&ldquo;Freewave&rdquo; </strong>romance audiobooks
              application, both the mobile and web version (&ldquo;
              <strong>App</strong>&rdquo;), our websites{" "}
              <a href="https://wromance.com/">
                <u>https://wromance.com/</u>
              </a>{" "}
              and{" "}
              <a href="https://temptromance.com/">
                <u>https://temptromance.com/</u>
              </a>{" "}
              (&ldquo;<strong>Websites</strong>&rdquo;), our official social
              networks pages (&ldquo;<strong>Social Networks Pages</strong>
              &rdquo;), all together referred as the &ldquo;
              <strong>Services</strong>&rdquo;. This Privacy Policy explains how
              we collect, store, use and share your personal data and how you
              can exercise your privacy rights. This Privacy Policy is&nbsp;an
              integral part of our{" "}
              <a href="https://wromance.com/terms_and_conditions">
                <u>Terms &amp; Conditions</u>
              </a>
              &nbsp;(&ldquo;<strong>Terms</strong>&rdquo;).
            </p>
            <p>
              <strong>Womanly Corp</strong>, with registered address at:&nbsp;8
              The Green, Suite A, City of Dover, Delaware 19901,&nbsp;United
              States (&ldquo;<strong>we</strong>&rdquo; or &ldquo;
              <strong>us</strong>&rdquo;), is a data controller with respect to
              your data processed in accordance with this Privacy Policy.
            </p>
            <p>
              We may update our Privacy Policy from time to time. When we do, we
              will revise the date at the top of the Policy. If we make changes
              that are material, we will use reasonable efforts to notify you
              (such as via an in-app notice or a push-notification). We
              encourage you to check this Privacy Policy regularly for updates,
              so that you know our current practices.
            </p>
            <p>
              By downloading, accessing and/or using the Services, you
              acknowledge the collection and use of your information in
              accordance with this Privacy Policy, including our and our
              partners&rsquo; use of your data for the purposes as described
              below.
            </p>
            <p>
              PLEASE, READ THE FOLLOWING CAREFULLY AND MAKE SURE YOU FULLY
              UNDERSTAND THIS PRIVACY POLICY. IF YOU HAVE ANY CONCERNS ABOUT
              PROVIDING INFORMATION TO US OR IT BEING USED AS DESCRIBED IN THIS
              PRIVACY POLICY, PLEASE, DISCONTINUE AND AVOID USING THE SERVICES.
            </p>
            <p>&nbsp;</p>
            <ol className="awlist1">
              <li>
                1. DATA COLLECTED&nbsp;
                <ol className="awlist2">
                  <li>
                    <strong>
                      <u>1.1 Within the use of the App</u>
                    </strong>
                    :
                    <p>
                     We collect the following types of personal data about you:&nbsp;
                    </p>
                    <ol className="awlist3">
                      <li>
                        <strong>1.1.1 Data provided by you</strong>
                        <ul className="awlist4">
                          <li>
                            Data you voluntarily
                            provide to us at your sole discretion.
                          </li>
                          <p>
                            We do not require you to provide us with any personal data, in
                            addition to those we get from your Apple, Facebook, Google or
                            other third-party account when you sign-in to the App using these
                            tools (see Clause 1.1.3 for more details). However, if you
                            voluntarily choose to provide us with any data when you contact us
                            via the App, we will process such data in accordance with this
                            Privacy Policy. For example, if you decide to contact us with a
                            request, we will process the content of your message, the date and
                            time of your message, our response and any other personal data you
                            provide in that context. If you decide to have a chat in the App,
                            we will process the details of your conversation.
                          </p>
                        </ul>
                      </li>
                    </ol>
                    <ol className="awlist5">
                      <li>
                        <strong>1.1.2. Data collected by us automatically</strong>
                      </li>
                      <p>We will automatically collect the following data of yours:</p>
                      <ul className="awlist4">
                        <li>
                          <u>Usage data</u>, i.e. data
                          about your use of the App (e.g. the date and time you used the
                          App, session length, liked and saved books, App version, App
                          install date, your interaction with advertisements (including
                          clicks, views, impressions) and your interaction with other
                          users, crash logs (errors, bugs), privacy preferences);
                        </li>
                        <li>
                          <u>IP address;</u>
                        </li>
                        <li>
                          
                          <u>Approximate location data,</u> such as country or city-level
                          location inferred from your IP address (we do not collect
                          precise geolocation);
                        </li>
                        <li>
                          <u>Device identifiers</u> (such
                          as your device ID, MAC address, IMEI);
                        </li>
                        <li>
                          
                          <u>First-party user identifiers</u> (our own identifiers we
                          assign to distinguish users);
                        </li>
                        <li>
                          
                          <u>Third-party user identifiers</u> (such as Firebase ID, Adjust
                          ID, and other identifiers generated by a third party);
                        </li>
                        <li>
                          <u>Advertising identifiers</u>{" "}
                          (such as IDFA, AAID);
                        </li>
                        <li>
                          <u>Device data</u>, such as
                          device manufacturer, device type, device model, RAM, operating
                          system name and its version, device performance information,
                          browser type, time zone, language, locale, timestamp, HTTP
                          header, push notification token, platform, and other technical
                          data like screen resolution or processor, or combination of this
                          data (for checking the device compatibility with the App), if ad
                          tracking is limited.
                        </li>
                      </ul>
                    </ol>
                    <ol className="awlist6">
                      <li>
                        <strong>1.1.3. Data provided by third parties</strong>
                      </li>
                      <p>
                        We may receive information relating to you and your use of the App
                        from the following third-party providers:
                      </p>
                      <ul className="awlist7">
                        <li>
                          <u>Analytics Providers</u>
                          <strong>. </strong>Our analytics providers may provide us
                          with:&nbsp;
                          <ul className="awlist8">
                            <li>
                              Data about your use of the
                              App (such as in-app events, your interaction with the App,
                              software bugs and errors, etc.) so that we could improve the
                              App and detect and prevent fraud in our Services;
                            </li>
                            <li>
                              Data about the performance
                              of our advertising campaigns (e.g. we may be provided with
                              information from which ad network and advertising campaign
                              the install of the App originated from, or data on fraud
                              traffic such as refund abuse in games or click fraud in
                              advertising);
                            </li>
                            <li>
                              Other data mentioned in
                              clause 1.1.2 above.
                            </li>
                          </ul>
                        </li>
                        <li>
                          <u>Marketing Partners</u>. From
                          time to time, we may receive non-personal information from our
                          marketing partners concerning the performance of our advertising
                          campaigns displayed outside our Services (e.g. we may be
                          provided with data about interaction with our advertisement
                          (such as clicks, views, impressions, installs or other
                          advertising campaign performance indicators).
                        </li>
                        <li>
                          <u>Sign-In Tools</u>. When your
                          account in the App is linked to your Apple, Facebook, Google or
                          other third-party account (&ldquo;<strong>Sign-In Tools</strong>
                          &rdquo;), such Sign-In Tools will share with us certain bulk of
                          your personal data. What data they will share will depend on
                          your privacy setting within those Sign-In Tools, but it&nbsp;
                          <em>would typically include</em>&nbsp;
                          <em>your basic profile information</em>&nbsp;
                          <em>
                            such as your name, user ID, user token, email address,
                            language preference and profile picture
                          </em>
                          . If you want to limit the sharing of data with us, you need to
                          regulate this in the privacy settings of the relevant Sign-In
                          Tool.&nbsp;We do not get access to or store your logins or
                          passwords for any of these Sign-In Tools.&nbsp;We encourage you
                          to review privacy policies and terms of service of&nbsp;Sign-In
                          Tools&nbsp;for further information before linking your account
                          in&nbsp;Sign-In Tools with the App.
                        </li>
                        <li>
                          <u>Online Stores</u>. As all
                          the purchases within the mobile version of the App run via Apple
                          Store or Google Play Store (&ldquo;
                          <strong>Online Stores</strong>&rdquo;), we will get limited data
                          on your purchases from the Online Stores, which would&nbsp;
                          <em>
                            typically include a list of purchased items, id of operation,
                            date, time, id, amount and currency of purchase
                          </em>
                          . We will not get your sensitive financial data, such as your
                          credit card number or bank account data. We encourage you to
                          review privacy policies and terms of service of the platforms
                          for further information before making a purchase in the Online
                          Stores.
                        </li>
                        <li>
                          <u>Payment Processors</u>. The
                          purchases within the website version of the App run with
                          assistance of payment processors. Please note that payment
                          processors will not share any sensitive financial data with us,
                          like bank card or bank account details, we will get a very
                          limited scope of data, like&nbsp;
                          <em>
                            id of operation, time, id, amount and currency of purchase.{" "}
                          </em>
                          We encourage you to review privacy policies and terms of service
                          of payment processors for further information before making a
                          purchase with their assistance.
                        </li>
                      </ul>
                    </ol>
                  </li>
                  <li>
                    <strong>
                      <u>1.2. Within the use of the Websites</u>
                    </strong>
                    :
                    <p>
                      We collect the following types of personal data about you:&nbsp;
                    </p>
                    <ol className="awlist10">
                      <li>
                        <strong>1.2.1. Cookies </strong>
                      </li>
                      <p>
                        Like most online services, we and our partners use cookies and
                        similar technologies to provide and personalize the Services,
                        analyze use, target advertisements and prevent fraud. You can
                        disable cookies, but some parts of the Services may then not
                        function properly. For further information, please, read our&nbsp;
                        <a href="/cookie_policy">Cookie Policy</a>
                      </p>
                    </ol>
                    <ol className="awlist11">
                      <li>
                        <strong>1.2.2. Data provided by you via the Websites</strong>
                      </li>
                      <p>
                        If you decide to contact us via the Website (e.g. leaving your
                        e-mail to get the personalized list of recommended romance books)
                        we will process all the data related to such messages in
                        accordance with this Privacy Policy. In particular, we will
                        process your name, e-mail, content of your message, the date and
                        time of your message, our response and any other personal data you
                        provide in that context.
                      </p>
                    </ol>
                    <ol className="awlist12">
                      <li>
                        <strong>1.2.3 Device data&nbsp;</strong>
                      </li>
                      <p>
                        We shall also collect the data about your device, like browser
                        type, language settings, IP address, platform, model and operating
                        system of the device.
                      </p>
                    </ol>
                  </li>
                  <li>
                    <strong>
                      <u>1.3. Within the use of the Social Networks</u>
                    </strong>
                    :
                    <p>
                      When you somehow interact with our Social Networks Pages (e.g.
                      visit pages, like the pages / posts, forward them, write messages
                      to the posts or to us directly, reference us), we shall collect
                      the following types of personal data about you:
                    </p>
                    <ol className="awlist14">
                      <li>
                        <strong>1.3.1 Data provided by you</strong>
                      </li>
                      <p>
                        If you decide to contact us via our Social Networks Pages,
                        we&nbsp;will process all the data related to such messages, like
                        your profile name, the&nbsp;content of your message, the date and
                        time of your message and our response.
                      </p>
                    </ol>
                    <ol className="awlist15">
                      <li>
                        <strong>1.3.2. Data collected by us</strong>
                      </li>
                      <p>
                        When you somehow interact with our Social Networks Pages we may
                        process all the details of such interaction (e.g. visiting pages,
                        liking the pages / posts, forwarding them, writing messages to the
                        posts or to us directly, referencing us).
                      </p>
                    </ol>
                    <ol className="awlist16">
                      <li>
                        <strong>1.3.3. Data provided by third parties</strong>
                      </li>
                      <p>
                        We may receive information relating to you from the following
                        third parties:
                      </p>
                      <ul className="awlist4">
                        <li>
                          <u>Social Networks Providers.</u>&nbsp;Social Networks providers
                          may share with us certain statistics and analytics data about
                          you. For instance, we operate a&nbsp;
                          <a href="https://www.facebook.com/WRomance-102424909093221/">
                            <u>page on Facebook</u>
                          </a>
                          , a service of Meta. Meta collects and uses your data to provide
                          analytics services, known as&nbsp;<u>"Page Insights"</u>
                          &nbsp;for the page admins to gain insight into how people
                          interact with their page and the content associated with them.
                          This data includes information about the types of content users
                          view or interact with, or the actions they take, as well as
                          information about the devices users use, such as IP addresses,
                          operating system, browser type, language settings, cookie data.
                          For more information on which data Meta may share with us&nbsp;
                          <a href="https://www.facebook.com/legal/terms/information_about_page_insights_data">
                            <u>see Information about Page Insights</u>
                          </a>
                          . We and Meta are jointly responsible for the collection and
                          processing of such data. You can view the terms and conditions
                          of the contract concluded with Meta&nbsp;
                          <a href="https://www.facebook.com/legal/controller_addendum">
                            <u>here</u>
                          </a>
                          . You can find Meta's privacy policy&nbsp;
                          <a href="https://www.facebook.com/privacy/policy/">
                            <u>here</u>
                          </a>
                          .
                        </li>
                        <li>
                          &nbsp;
                          <u>Analytics Providers</u>
                          <strong>.&nbsp;</strong>Our analytics providers may provide us
                          with some aggregated data on our Social Networks visitors and
                          subscribers, like approximate age and gender (however these data
                          are always aggregated, i.e. we cannot know your particular age
                          and gender using them).
                        </li>
                      </ul>
                    </ol>
                  </li>
                  <li>
                    <strong>
                      <u>1.4. Within other sources</u>
                    </strong>
                    <p>
                      You may contact us via email or other communication channels,
                      regarding any issues (related to the App or not). In this case we
                      will process all the data provided by you within such
                      communication in accordance with this Privacy Policy (we will
                      process the content of your message, the date and time of your
                      message, our response and any other personal data you provide in
                      that context).
                    </p>
                  </li>
                  <li>
                      <strong><u>1.5</u></strong>&nbsp; We do not request or intend to collect any sensitive data (&ldquo;special
                    categories of information&rdquo;), such as data revealing racial
                    or ethnic origin, political opinion, religious or philosophical
                    beliefs, or trade union membership, genetic data, biometric
                    data, data concerning health or data concerning a natural
                    person&rsquo;s sex life or sexual orientation. Please, be
                    cautious when sharing this information about yourself (or
                    others) via the Services.
                  </li>
                </ol>
              </li>
              <li>
                2. PURPOSES AND
                BASIS FOR PROCESSING&nbsp;
                <ol>
                  <li>
                    2.1 We will
                    process your personal data for the following purposes and on
                    the following basis:&nbsp;
                    <table>
                      <tbody>
                      <tr>
                        <td>
                          <p>
                            <strong>&nbsp;</strong>
                          </p>
                        </td>
                        <td>
                          <p>
                            <strong>Purpose shortly</strong>
                          </p>
                        </td>
                        <td>
                          <p>
                            <strong>Purpose in detail</strong>
                          </p>
                        </td>
                        <td>
                          <p>
                            <strong>Legal Basis (Data Needed for)</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            <strong>2.1.1.</strong>
                          </p>
                        </td>
                        <td colSpan={3}>
                          <p>
                            <strong>
                              <u>Data collected within the use of the App</u>
                            </strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(a)</p>
                        </td>
                        <td>
                          <p>
                            <strong>Making the App work</strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist20">
                            <li>
                              Enabling you to use the
                              App (facilitating, operating, providing and maintaining
                              the App availability, operability and proper
                              functioning, fixing bugs and errors)
                            </li>
                            <li>
                              Recognizing you when
                              you return to the App or when you change the devices,
                              allowing you to synchronise progress in the App across
                              multiple devices
                            </li>
                            <li>
                              Verifying and
                              confirming payments of in-app purchases
                            </li>
                            <li>
                              Sending you the
                              app-related communications (security alerts, updates,
                              other notifications)
                            </li>
                            <li>
                              Responding to your
                              comments and questions and providing customer support
                            </li>
                            <li>
                              Protecting the security
                              and integrity of the App
                            </li>
                            <li>
                              Localising the App and
                              App content for you
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Performance of a&nbsp;<strong>contract</strong>&nbsp;which
                            you enter into when you download or access the App and
                            accept our Terms&nbsp;
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(b)</p>
                        </td>
                        <td>
                          <p>
                            <strong>
                              Improving the App and your in-app experience
                            </strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist21">
                            <li>
                              Monitoring and
                              analyzing the use of the App to improve the App
                              operation and functionality, to identify bugs and errors
                              in the App, to understand and analyze the usage trends
                              and preferences of our users, the App user audience, and
                              to otherwise improve and customize (personalize) the App
                              content for you and your in-app experience
                            </li>
                            <li>
                              Testing the new
                              features of the App
                            </li>
                            <li>
                              Running surveys to get
                              your feedback about the App from time to time
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Our&nbsp;<strong>legitimate interest</strong>&nbsp;to
                            improve and optimize the App and enhance user experience
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(c)</p>
                        </td>
                        <td>
                          <p>
                            <strong>Ensuring compliance with the Terms&nbsp;</strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist22">
                            <li>
                              Detecting, preventing
                              and combating potential or actual breaches of the Terms,
                              which includes monitoring the use of the App,
                              investigating suspicious activity within the App, taking
                              actions against the users violating the Terms
                            </li>
                            <li>
                              Defending ourselves
                              against any third-party claims or allegations
                            </li>
                            <li>
                              Detecting, preventing
                              and combating unlawful actions of users
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Our&nbsp;<strong>legitimate interest</strong>&nbsp;to keep
                            the App safe, to fight fraud, ensure security of the App
                            and protect our interests
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(d)</p>
                        </td>
                        <td>
                          <p>
                            <strong>Ensuring compliance with applicable law</strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist23">
                            <li>
                              Complying with legal
                              obligations, including complying with orders from a
                              court or regulatory authority, responding to request
                              from regulatory authorities
                            </li>
                            <li>
                              Detecting your
                              jurisdiction, to consider which specific laws do apply
                              to you and whether we need to disable or change some
                              features to stay compliant with those specific laws
                            </li>
                            <li>
                              Detecting, preventing
                              and combating unlawful actions of users
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Compliance with&nbsp;<strong>legal obligations</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(e)</p>
                        </td>
                        <td>
                          <p>
                            <strong>
                              Promoting the App / Measuring performance of marketing
                              campaigns
                            </strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist24">
                            <li>
                              Reaching the audience
                              that may be interested in the App
                            </li>
                            <li>
                              Tracking and
                              attributing App installations, analysing where a user
                              comes from&nbsp;
                            </li>
                            <li>
                              Detecting fraudulent
                              traffic
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Our&nbsp;<strong>legitimate interest</strong>&nbsp;to
                            advertise and promote the App
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(f)</p>
                        </td>
                        <td>
                          <p>
                            <strong>
                              Serving you third-party ads within the App
                            </strong>
                          </p>
                        </td>
                        <td>
                          <p>Serving you (using third party advertising networks):</p>
                          <p>&nbsp;</p>
                          <ul className="awlist25">
                            <li>
                              generic, contextual
                              (non-personalized) advertisements
                            </li>
                            <li>
                              targeted (personalized)
                              advertisements (for which purposes tracking the content
                              you access within the App and your online
                              behaviour)&nbsp;
                            </li>
                          </ul>
                          <p>&nbsp;</p>
                          <p>
                            <em>
                              <u>NOTE*:</u>
                            </em>
                            <em> you may </em>
                            <em>
                              opt out of personalized advertising via your device
                              settings (see Section 6 below)&nbsp;
                            </em>
                            <em>
                              <u>and</u>
                            </em>
                            <em>&nbsp;withdraw your consent to showing you&nbsp;</em>
                            <em>
                              personalized ads by contacting us (as described in
                              section 10)
                            </em>
                          </p>
                          <p>
                            <em>&nbsp;</em>
                          </p>
                          <p>
                            <em>
                              <u>NOTE**:</u>
                            </em>
                            <em>
                              {" "}
                              for showing personalized we use Google CMP (Consent
                              Management Platform) to receive your consent
                            </em>
                          </p>
                        </td>
                        <td>
                          <p>
                            Our&nbsp;<strong>legitimate interest</strong>&nbsp;in
                            monetizing the App (for non-personalized ads)
                          </p>
                          <p>
                            <strong>Consent</strong>&nbsp;(for personalized ads)
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            <strong>2.1.2.</strong>
                          </p>
                        </td>
                        <td colSpan={3}>
                          <p>
                            <strong>
                              <u>Data collected within the use of the Websites</u>
                            </strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(a)</p>
                        </td>
                        <td>
                          <p>
                            <strong>Making the Websites work</strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist26">
                            <li>
                              Enabling availability,
                              operability and proper functioning of the Websites
                              (essential cookies)
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Performance of a&nbsp;<strong>contract</strong>&nbsp;which
                            you enter into when you access the Website&nbsp;
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(b)</p>
                        </td>
                        <td>
                          <p>
                            <strong>
                              Improving the Websites and their visitor experience
                            </strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist27">
                            <li>
                              Monitoring and
                              analyzing the use of the Websites to improve its
                              operation and functionality, to identify bugs and errors
                              in the Websites, to improve the visitors experience
                              (performance / functional cookies)
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>Depending on the jurisdiction:</p>
                          <p>
                            Our&nbsp;<strong>legitimate interest</strong>&nbsp;to
                            improve and optimize the Websites and visitor experience
                          </p>
                          <p>
                            <strong>Consent</strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(c)</p>
                        </td>
                        <td>
                          <p>
                            <strong>Responding to your requests</strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist28">
                            <li>
                              Responding to your
                              questions, applications, requests, other messages
                              submitted via the Websites
                            </li>
                          </ul>
                          <p>&nbsp;</p>
                        </td>
                        <td>
                          <p>
                            Depends solely on the subject of the request (e.g. if the
                            request relates to the App, that would be contract
                            performance)
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(d)</p>
                        </td>
                        <td>
                          <p>
                            <strong>
                              Protecting the Websites operability / content
                            </strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist29">
                            <li>
                              Protecting security and
                              integrity of the Websites (against DDoS and other cyber
                              attacks)
                            </li>
                            <li>
                              Detecting, preventing
                              and combating unlawful actions of Websites visitors
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Our&nbsp;<strong>legitimate interest</strong>&nbsp;to
                            ensure security of the Websites and protect our interests
                            against unlawful actions
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            <strong>2.1.3.</strong>
                          </p>
                        </td>
                        <td colSpan={3}>
                          <p>
                            <strong>
                              <u>Data collected within the use of Social Networks</u>
                            </strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(a)</p>
                        </td>
                        <td>
                          <p>
                            <strong>
                              Responding to your messages and actions&nbsp;
                            </strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist30">
                            <li>
                              Responding to your
                              questions, applications, requests, other messages
                              submitted via our Social Networks Pages
                            </li>
                            <li>
                              Reacting to your
                              actions with regard to our Social Networks Pages (e.g.
                              likes, follows, recommendations, sharing, etc.)
                            </li>
                          </ul>
                          <p>&nbsp;</p>
                        </td>
                        <td>
                          <p>
                            Performance of a&nbsp;<strong>contract</strong>&nbsp;(as
                            our Social Networks Pages relate solely to the App)
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(b)</p>
                        </td>
                        <td>
                          <p>
                            <strong>
                              Improving our Social Networks Pages and their visitor
                              experience
                            </strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist31">
                            <li>
                              Understanding the
                              target audience of our Social Networks Pages
                            </li>
                            <li>
                              Understanding which
                              content and promotional activities are of the most
                              interest for our Social Networks audience
                            </li>
                            <li>
                              Measuring, adjusting
                              and improving effectiveness of such content / activities
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Our&nbsp;<strong>legitimate interest</strong>&nbsp;to
                            enhance the content of Social Networks Pages and user
                            experience
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(c)</p>
                        </td>
                        <td>
                          <p>
                            <strong>
                              Combating unlawful actions of Social Networks users
                            </strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist32">
                            <li>
                              Detecting, preventing
                              and combating unlawful actions of users
                            </li>
                          </ul>
                        </td>
                        <td>
                          <p>
                            Our&nbsp;<strong>legitimate interest</strong>&nbsp;to
                            protect our interests against unlawful actions
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            <strong>2.1.4.</strong>
                          </p>
                        </td>
                        <td colSpan={3}>
                          <p>
                            <strong>
                              <u>Data collected within other sources</u>
                            </strong>
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>(a)</p>
                        </td>
                        <td>
                          <p>
                            <strong>Responding to your requests</strong>
                          </p>
                        </td>
                        <td>
                          <ul className="awlist33">
                            <li>
                              Responding to your
                              questions, applications, requests, other messages
                              submitted via email or other&nbsp;communication channels
                            </li>
                          </ul>
                          <p>&nbsp;</p>
                        </td>
                        <td>
                          <p>
                            Depends solely on the subject of the request (e.g. if the
                            request relates to the App, that would be contract
                            performance)
                          </p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </li>
                  <li>
                    <br/>
                    2.2 We may also ask
                    for your consent in certain cases when we are required to ask
                    for it under the applicable terms of the Online Stores (e.g. to
                    send you push notifications, to track your activity across other
                    companies&rsquo; apps and websites, etc.).
                  </li>
                  <li>
                    2.3. We do not carry
                    out any decision-making having legal effects for you based
                    solely on automated processing, including profiling.
                  </li>
                </ol>
              </li>
              <li>
                3. SHARING OF
                DATA&nbsp;
                <ol className="awlist2">
                  <li>
                    3.1 We may share
                    your personal data with:
                    <ol className="awlist36">
                      <li>
                       3.1.1. Our
                        service providers and other partners, who perform the
                        following functions / services:
                        <br/> <br/>
                        <table>
                          <tbody>
                          <tr>
                            <td>
                              <p>
                                <strong>Cloud storage providers</strong>
                              </p>
                            </td>
                            <td>
                              <p>we engage them for storage of Services data</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Payment processors</strong>
                              </p>
                            </td>
                            <td>
                              <p>we engage them to process payments for our Services</p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Analytics services</strong>
                              </p>
                            </td>
                            <td>
                              <p>
                                we engage them for analytics, attribution and mobile
                                measurement services which allows us to improve our
                                Services through data analysis and know our audience
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Customer support</strong>
                              </p>
                            </td>
                            <td>
                              <p>
                                we collaborate with them to facilitate customers requests
                                and questions
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Marketing partners</strong>
                              </p>
                            </td>
                            <td>
                              <p>
                                we collaborate with several marketing partners who help us
                                advertise our Services, they assist us in measuring and
                                optimizing our advertising campaigns so we can reach
                                audiences interested in our Services and expand our user
                                base
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Advertising networks</strong>
                              </p>
                            </td>
                            <td>
                              <p>
                                we may also share information with advertising partners
                                who distribute advertising in our Services or allow them
                                to collect data directly from you through their mobile
                                SDKs or similar technologies embedded in our Services. We
                                share a very limited scope of data with our advertising
                                partners (networks): for non-personalized ads that&rsquo;s
                                usually the IP address, some device IDs, with respect to
                                personalized ads that could be also some data on your
                                behavior within the App, e.g. the content that you access.
                                Our advertising partners may combine this information with
                                data they have collected about you when you use their
                                services or third-party websites and services. This helps
                                them show you more relevant advertising in our Services
                                and improve their ad targeting and measurement systems. We
                                advise you to сheck their privacy policy for further
                                details
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>
                                <strong>Other service providers</strong>
                              </p>
                            </td>
                            <td>
                              <p>
                                we may engage other service providers, e.g. assisting us
                                with software maintenance, technical support, security
                                issues, external auditors, etc.
                              </p>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </li>
                      <li>
                        <br/>
                        3.1.2. State authorities
                        and institutions (upon their requests, when otherwise required
                        under applicable law or on our initiative in order to combat the
                        violations of the Terms);
                      </li>
                      <li>
                        3.1.3. Our affiliated
                        companies;
                      </li>
                      <li>
                        3.1.4 Acquiring party
                        or assignee in the event of a proposed or
                        actual&nbsp;&nbsp;reorganization, merger, sale, joint venture,
                        assignment, transfer or other disposition of all or any portion
                        of our company or its assets;
                      </li>
                      <li>
                        3.1.5 Other third
                        parties, providing such sharing is needed for the purposes of
                        processing listed above or upon your consent for this.
                      </li>
                    </ol>
                  </li>
                  <li>
                    3.2. You may find the
                    current List of our service providers and other partners&nbsp;
                    <a href="/list_partners">here</a>.
                  </li>
                  <li>
                    3.3. We share your
                    personal data with these third parties only for the purposes
                    listed in Section 2 above, where we have a legal basis for this
                    and to the extent such sharing is needed to achieve the purpose.
                    Such third parties will provide the same or equal protection of
                    your data as stated in this Privacy Policy and required by
                    applicable laws and Online Stores guidelines.
                  </li>
                  <li>
                    3.4. Information about
                    you may be also disclosed and otherwise transferred to an
                    acquirer, successor, or assignee as part of any merger,
                    acquisition, sale of assets, or similar transaction.
                  </li>
                </ol>
              </li>
              <li>
                4. INTERNATIONAL
                DATA TRANSFERS&nbsp;
                <ol className="awlist2">
                  <li>
                    <p>4.1. Our Services
                      are global by nature and your data can therefore be
                      transferred and processed in countries other than the
                      country in which you are resident, which sometimes may offer
                      a lower level of protection compared to the one provided in
                      your home jurisdiction. We will always take steps to ensure
                      adequate safeguards are in place to protect your data within
                      such transfers. Adequate safeguards that we and our partners
                      may use include transfer of data to the jurisdictions, which
                      are considered by the European Commission to be offering an
                      adequate level of protection, or entering into standard
                      contractual clauses approved by the EU Commission with the
                      respective recipients.</p>
                    
                  </li>
                </ol>
              </li>
              <li>
                5. YOUR RIGHTS
                <ol className="awlist2">
                  <li>
                    5.1. You will
                    generally have the following rights with regard to our
                    processing of your personal data (
                    <em>
                      the full set of rights you have will always depend on your
                      home jurisdiction and the particular circumstances of
                      processing; some of the rights have their particular
                      execution conditions, i.e. can be exercised providing
                      certain conditions are met
                    </em>
                    ):
                    <ol className="awlist36">
                      <li>
                        <strong>5.1.1. Right to access:</strong>&nbsp;You have the
                        right to access the personal data we hold about you and
                        certain information about processing of such data (e.g.
                        categories of data collected, purposes of processing,
                        data recipients, retention period, the sources of
                        collected data, etc.);
                      </li>
                      <li>
                        <strong>5.1.2. Right to rectification:</strong>&nbsp;You have
                        the right to request us to rectify your personal data
                        (if they are inaccurate or incomplete);&nbsp;
                      </li>
                      <li>
                        <strong>5.1.3 Right to erasure:</strong>&nbsp;You have the
                        right to request the erasure of your personal data
                        (where we do not have a legal basis to continue to
                        process such personal data or in other particular
                        circumstances);
                      </li>
                      <li>
                        <strong>5.1.4. Right to data portability: </strong>You have the
                        right to receive the personal data you have provided us
                        with, in a structured, commonly used and
                        machine-readable format, as well as to request us to
                        transfer your personal data to another controller, where
                        this is technically feasible (in certain circumstances
                        and under certain conditions);
                      </li>
                      <li>
                        <strong>5.1.5. Right to withdraw consent: </strong>You have the
                        right to withdraw your consent (when we rely on consent
                        as the legal basis for processing). Note that withdrawal
                        of your consent will not affect the lawfulness of any
                        processing we conducted prior to your withdrawal, nor
                        will it affect the processing of your personal data
                        conducted pursuant to lawful processing grounds other
                        than consent;
                      </li>
                      <li>
                        <strong>5.1.6. Right to opt-out: </strong>to opt out of
                        personalized advertising via your device settings or
                        privacy settings of the App (see Section 6 below);
                      </li>
                      <li>
                        <strong>
                          5.1.7. Right not to be subject to a decision based solely on
                          automated processing:{" "}
                        </strong>
                        You have the right not to be subject to a decision based
                        solely on automated processing (including profiling)
                        which produces legal effects or could significantly
                        affect you;
                      </li>
                      <li>
                        <strong>5.1.8. Right to object: </strong>You have the right to
                        object to or restrict how we process your data (in
                        certain circumstances). Please note in case of such a
                        request we may not be always able to provide you with
                        all the Services functionalities and / or the Services
                        performance may suffer;
                      </li>
                      <li>
                        <strong>5.1.9. Right to lodge a complaint: </strong>You have
                        the right to lodge a complaint with a data protection
                        supervisory authority (if you think that any of your
                        rights have been violated by us).
                      </li>
                    </ol>
                  </li>
                  <li>
                    5.2. Please note
                    that residents of certain US states have specific rights,
                    which are sometimes different from those mentioned above
                    (see &ldquo;<u>US Privacy Addendum</u>&rdquo; attached
                    hereto for more details).
                  </li>
                  <li>
                    5.3. If you wish to exercise any of the above rights, please contact us via
                    (i) the in-app support feature (Option 1) or (ii) the
                    contact details in Section 10 of Privacy Policy (Option 2).
                    If using Option 2, please note that we may still redirect
                    you to make the same request through the in-app support
                    feature to verify you as our user and/or request additional
                    information necessary for us to respond. Please, note that
                    your request for exercising any of your rights must:
                    <ol className="awlist36">
                      <li>
                        5.3.1. provide
                        sufficient information necessary to verify you as an
                        individual about whom we collected and processed
                        personal data or to verify you as an authorized
                        representative of such a user;
                      </li>
                      <li>
                        5.3.2. contain
                        sufficient details describing your request to allow us
                        to properly understand, review and respond to it.
                      </li>
                    </ol>
                  </li>
                  <li>
                    5.4. We reserve the right to ask for reasonable information to verify your
                    identity before we process your request, and not to respond
                    to your request or provide you with personal data, in case
                    we are unable to verify your identity or authority to make
                    such a request.
                  </li>
                  <li>
                    5.5. Permissible
                    number of requests, whether they are free of charge or not,
                    and other conditions of requests shall fully depend on your
                    home jurisdiction requirements.
                  </li>
                </ol>
              </li>
              <li>
                6. PERSONALIZED
                ADVERTISING
                <ol className="awlist2">
                  <li>
                    6.1. You can&nbsp;
                    <strong>
                      <u>
                        opt-out of personalized advertising within the App&nbsp;
                      </u>
                    </strong>
                    via your device settings or the App privacy settings:
                    <ol className="awlist36">
                      <li>
                        6.1.1. 
                        <strong>
                          Option 1 &ndash; CMP Start Page &ndash;{" "}
                        </strong>
                        If&nbsp;Google CMP (Consent Management Platform) is
                        implemented for your region, after the launch of the App
                        you will see the screen asking for your consent for
                        various purposes of processing, including for
                        personalized advertising. If you want to opt out from
                        personalized advertising make your choices accordingly.
                      </li>
                      <li>
                        6.1.2. 
                        <strong>Option 2 &ndash; App Settings </strong>
                        (where&nbsp;Google CMP (Consent Management Platform) is
                        implemented for your region):
                        <ul className="awlist4">
                          <li>
                            Open App settings
                            menu
                          </li>
                          <li>
                            Select
                            &ldquo;Consent Preferences&rdquo;&nbsp;
                          </li>
                          <li>
                            Tap &ldquo;Manage
                            preferences&rdquo; and adjust your choices
                          </li>
                        </ul>
                      </li>
                      <li>
                        6.1.3. 
                        <strong>Option 3 &ndash; App Settings</strong>
                        &nbsp;(where US Privacy Laws apply - see&nbsp;&ldquo;
                        <u>US Privacy Addendum</u>&rdquo; attached hereto for
                        more details)
                      </li>
                      <li>
                        6.1.4. 
                        <strong>Option 4 &ndash; Device Settings</strong>
                        <p>On iOS:</p>
                        <ul className="awlist4">
                          <li>
                            Open &ldquo;Settings&rdquo;
                          </li>
                          <li>
                            Select &ldquo;Privacy&rdquo; /
                            &ldquo;Privacy &amp; Security&rdquo;
                          </li>
                          <li>
                            Select &ldquo;Tracking&rdquo;
                            and disable &ldquo;Allow Apps to Request to Track&rdquo;,&nbsp;
                            <u>or</u>&nbsp;select &ldquo;Advertising&rdquo; and enable
                            "Limit Ad Tracking"
                          </li>
                        </ul>
                        <p>On Android:</p>
                        <ul className="awlist40">
                          <li>
                            Open &ldquo;Settings&rdquo;
                          </li>
                          <li>
                            Tap &ldquo;Privacy&rdquo; &gt;
                            (&ldquo;Advanced&rdquo;) &gt; &ldquo;Ads&rdquo;
                          </li>
                          <li>
                            Tap &ldquo;Delete advertising
                            ID&rdquo; and confirm your changes,&nbsp;<u>or</u>&nbsp;Select
                            &ldquo;Ads&rdquo; and enable "Opt out of Ads Personalization".
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                  <li>
                    6.2. Please note that
                    opting out via any option described above does not mean that you
                    will stop seeing advertisements in our Services. Instead,
                    third-party advertising networks will consider your choice as
                    withdrawal of consent for personalised advertising experience
                    and will show you contextual (non-personalized) advertisements
                    not tailored to your interests in the same volume. Please be
                    aware that such actions may result in decrease of advertising
                    quality and less enjoyable user experience.
                  </li>
                  <li>
                    6.3. If you are
                    interested in more information about personalized advertising
                    and your choices in this regard, you may visit the following
                    websites:
                    <ol className="awlist42">
                      <li>
                        6.3.1. 
                        <a href="https://optout.networkadvertising.org/">
                          <u>
                            Network Advertising Initiative Consumer Opt-Out Page
                          </u>
                        </a>
                        &nbsp;(NAI's opt-out platform)
                      </li>
                      <li>
                        6.3.2.
                        <a href="https://optout.aboutads.info/">
                          <u>Digital Advertising Alliance Opt-Out Page</u>
                        </a>
                        &nbsp;(DAA's opt-out platform)
                      </li>
                      <li>
                        6.3.3.
                        <a href="https://www.youronlinechoices.com/uk/your-ad-choices">
                          <u>Your Online Choices Page</u>
                        </a>
                        &nbsp;(EDAA's opt-out platform)
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                7. AGE RESTRICTIONS
                <ol className="awlist2">
                  <li>
                    7.1. Our Services
                    are intended for use only by adults (i.e. individuals who
                    are over 18 years of age or of the age of majority in their
                    country, whichever is older). All the individuals of the
                    younger age we treat as children and do not allow them to
                    use our Services.
                  </li>
                  <li>
                    7.2. If we learn
                    that personal data has been collected via the Services from
                    children, then we will take the appropriate steps to delete
                    this personal data.
                  </li>
                  <li>
                    7.3. If you are a
                    parent or guardian and discover that your child is using the
                    Services and that we may have collected information from
                    that child through the Services, then you may alert us at{" "}
                    <a href="mailto:help@wromance.com">
                      <u>help@wromance.com</u>
                    </a>{" "}
                    and we will delete that child&rsquo;s personal data from our
                    systems as soon as possible.
                  </li>
                </ol>
              </li>
              <li>
                8. SECURITY SAFEGUARDS
                <ol className="awlist2">
                  <li>
                    8.1. We are
                    continuously developing and implementing administrative,
                    technical and physical security measures to protect the
                    confidentiality, security and integrity of the collected
                    data and to prevent from accidental or unlawful destruction,
                    loss, alteration, unauthorised disclosure of, or access to
                    the data under our control. In addition, we limit access to
                    personal data by our personnel and partners on a
                    need-to-know basis only.&nbsp;
                  </li>
                  <li>
                    8.2. Although we
                    use commercially reasonable efforts to assure that your data
                    remain secure when maintained by us, please, be aware that
                    no security measures are perfect or impenetrable.
                    Unfortunately, the transmission of data via the internet is
                    not completely secure and we cannot guarantee the security
                    of your data transmitted via the Services; any transmission
                    is at your own risk. We cannot and do not guarantee that
                    information about you will not be accessed, viewed,
                    disclosed, altered, or destroyed by breach of any of our
                    physical, technical, or managerial safeguards.
                  </li>
                </ol>
              </li>
              <li>
                9. DATA RETENTION
                <ol className="awlist2">
                  <li>
                    9.1. We store the
                    collected personal data of yours for as long as necessary to
                    fulfil the purposes we collected it for, including for
                    complying with our legal obligations. We may retain your
                    personal data for a longer period in the event of any
                    existing, upcoming or possible complaint, dispute or
                    litigation.
                  </li>
                  <li>
                    9.2. To determine
                    appropriate retention period with respect to your personal
                    data we consider the amount, nature and sensitivity of the
                    personal data, the potential risk of harm from unauthorised
                    use or disclosure of your personal data, the purposes for
                    which we process your personal data and whether we can
                    achieve those purposes through other means, as well as
                    applicable legal requirements.
                  </li>
                  <li>
                    9.3. In some
                    circumstances we can anonymise your personal data (so that
                    it can no longer be associated with you, even if combined
                    with other data) for analytical or statistical purposes, in
                    which case we may use this data indefinitely (i.e. also
                    after deletion of your account) without further notice to
                    you.
                  </li>
                </ol>
              </li>
              <li>
                10. CONTACT US
                <ol className="awlist2">
                  <li>
                    10.1. If you have
                    questions about this Privacy Policy, or if you have any
                    requests for exercising any of your privacy rights, you can
                    contact us through the in-app support feature (if available)
                    or via e-mail at&nbsp;
                    <a href="mailto:help@wromance.com">
                      <u>help@wromance.com</u>
                    </a>
                    . However, please note that we may still redirect you to
                    make the same request through the in-app support feature to
                    verify you as our user and/or request additional information
                    necessary for us to respond.
                  </li>
                </ol>
              </li>
            </ol>
            <p>&nbsp;</p>
            <h2>
              <strong>US PRIVACY ADDENDUM</strong>
            </h2>
            <p>&nbsp;</p>
            <ol className="awlist44">
              <li>
                <strong>1. SCOPE OF APPLICATION</strong>
                <ol className="awlist45">
                  <li>
                    1.1. This Addendum
                    provides additional information for residents of the
                    following US States:&nbsp;
                    <strong>California, Virginia</strong>&nbsp;(&ldquo;
                    <strong>US States</strong>&rdquo;), who have certain privacy
                    rights as specified under their state privacy acts (together
                    &ldquo;<strong>US Privacy Laws</strong>&rdquo;).
                  </li>
                </ol>
              </li>
              <li>
                <strong>2. YOUR RIGHTS</strong>
                <ol className="awlist45">
                  <li>
                    2.1. Below you
                    will find information what rights you may have and how to
                    exercise those rights and our process of handling those
                    requests:
                    <ol className="awlist46">
                      <li>
                         2.1.1 &nbsp;
                        <strong>Right to know: </strong>You have the right to
                        know before accessing the Services certain information
                        about processing of your personal data (e.g. categories
                        of data collected, purposes of processing, data
                        recipients, sources of collected data, etc.) (
                        <em>
                          We ensure this right by posting this Privacy Policy
                          both on the Website and on the{" "}
                        </em>
                        <em>
                          onboarding screen when you launch the App for the
                          first time
                        </em>
                        ).
                      </li>
                      <li>
                         2.1.2. &nbsp;
                        <strong>Right to access:</strong>&nbsp;You may request
                        us to disclose certain information about processing of
                        your personal data (e.g. categories of data collected,
                        purposes of processing, data recipients, sources of
                        collected data, etc.)&nbsp;<em>(</em>
                        <em>
                          <u>NOTE</u>
                        </em>
                        <em>
                          : the scope of data we have to disclose to you, the
                          period for which the data should be disclosed and the
                          frequency of free-of charge requests depend on your
                          state of residency; for instance, for California
                          residents - the disclosed personal information shall
                          be provided for the period of 12 (twelve) months
                          preceding the date of receiving your verifiable
                          request; Virginia residents may request the
                          information free of charge up to twice annually).
                        </em>
                      </li>
                      <li>
                        2.1.3. &nbsp;
                        <strong>Right to delete:</strong>&nbsp;You have the
                        right to request that we delete any of your personal
                        information we collected and retained, subject to
                        certain exceptions. Once we receive and verify your
                        consumer request, we will delete your personal
                        information from our records, will notify any service
                        providers and other third parties to whom we have sold
                        or shared your personal information to delete it from
                        their records, unless this proves impossible or involves
                        disproportionate effort. However, we may deny your
                        deletion request if retaining the information is
                        necessary for us or our service providers under certain
                        circumstances, which will be explained to you at the
                        time of the denial, if any.
                      </li>
                      <li>
                        2.1.4. &nbsp;
                        <strong>Right to correct:</strong>&nbsp;You have the
                        right to request to correct the inaccurate personal
                        information that we hold about you, taking into account
                        the nature of the personal information and the purposes
                        of the processing of the personal information.
                      </li>
                      <li>
                        2.1.5. &nbsp;
                        <strong>Right to data portability </strong>
                        <em>(for Virginia residents only)</em>
                        <strong>:</strong>&nbsp;You have the right to obtain
                        your personal data in a portable and, to the extent
                        technically feasible, readily usable format that allows
                        you to transmit your personal data to another controller
                        without hindrance.
                      </li>
                      <li>
                        2.1.6. &nbsp;
                        <strong>Right to opt-out:</strong>&nbsp;You have the
                        right to opt-out of the processing of the personal data
                        for purposes of (i) targeted advertising or
                        cross-contextual behavioral advertising, (ii) the
                        &ldquo;sale&rdquo; and/or sharing of personal data, or
                        (iii) profiling (or solely automated decisions that
                        produce legal or similarly significant effects
                        concerning you), as defined by the applicable US Privacy
                        Laws. If you would prefer that your personal information
                        is not shared with third parties in this way, please
                        visit&nbsp;
                        <a href="/do-not-sell-my-info">
                          Do Not Sell My Personal Information
                        </a>
                        .
                      </li>
                      <li>
                        2.1.7. &nbsp;
                        <strong>Right to be free from discrimination:</strong>
                        &nbsp;We may not discriminate against you for exercising
                        any of your rights under US Privacy Laws, including but
                        not limited to (i) denying you our Services; (ii)
                        charging you different prices or rates for our Services;
                        (iii) providing you a different level or quality of
                        Services; (iv) suggesting that you may receive a
                        different price or rate for Services or a different
                        level or quality of Services.
                      </li>
                      <li>
                        2.1.8. &nbsp;
                        <strong>
                          Right to limit use and disclosure of sensitive
                          personal information{" "}
                        </strong>
                        <em>(for California residents only)</em>: You have the
                        right, however we do not collect any sensitive personal
                        information.
                      </li>
                      <li>
                        2.1.9. &nbsp;
                        <strong>Right to appeal </strong>
                        <em>(for Virginia residents only): </em>You have the
                        right to appeal our decision to deny your privacy rights
                        request.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                 <strong>3. SUMBITTING A REQUEST</strong> 
                <ol className="awlist45">
                  <li>
                    3.1. To submit
                    your request, please use (i) the in-app support feature
                    (Option 1) or (ii) the contact details in Section 10 of
                    Privacy Policy (Option 2). If using Option 2, please note
                    that we may still redirect you to make the same request
                    through the in-app support feature to verify you as our user
                    and/or request additional information necessary for us to
                    respond.
                  </li>
                  <li>
                    3.2. Please note
                    that your request must:
                    <ol className="awlist46">
                      <li>
                        3.2.1. provide
                        sufficient information necessary to verify you as the
                        individual about whom we collected and processed
                        personal data or to verify you as an authorized
                        representative of such a user;
                      </li>
                      <li>
                        3.2.2. contain
                        sufficient details describing your request to allow us
                        to properly understand, review and respond to it.
                      </li>
                    </ol>
                  </li>
                  <li>
                    3.3. We reserve
                    the right to ask for reasonable information to verify your
                    identity before we process your request.
                  </li>
                  <li>
                    3.4. We will
                    respond to your request within 45 (forty five) days, and in
                    more difficult cases we may extend our response time by
                    another 45 (forty five)&nbsp;&nbsp;days. We reserve the
                    right not to respond to your request or provide you with
                    personal data, in case we were unable to verify your
                    identity or authority to make such a request.
                  </li>
                  <li>
                    3.5. If you are a
                    Virginia resident, you have the right to appeal our decision
                    to deny your rights request.
                  </li>
                </ol>
              </li>
              <li>
                 <strong>4. AUTHORIZED AGENTS</strong>
                <ol className="awlist45">
                  <li>
                    4.1. In certain
                    circumstances, you may exercise your rights by designating
                    an authorized agent. If you would like to designate an
                    authorized agent to make a request on your behalf, please be
                    sure that the agent can (i) demonstrate you have provided
                    written permission for the agent to submit a request on your
                    behalf and (ii) provide proof of his or her own identity. We
                    reserve the right to require further reasonable information
                    to verify the request. If the agent does not satisfy these
                    requirements, we may deny the request.
                  </li>
                </ol>
              </li>
              <li>
                 <strong>5. SELLING OF DATA&nbsp;</strong>
                <ol className="awlist45">
                  <li>
                    5.1. We do not
                    &ldquo;sell&rdquo; data of our users as most people would
                    typically understand this term. The definition of
                    &ldquo;selling&rdquo; shall be interpreted in accordance
                    with the meaning attributed to this term under US Privacy
                    Laws. We do, however, share certain data with third-party
                    advertising partners for the purposes of serving
                    advertisements tailored to your interests in our Services,
                    measure advertising performance, fraud detection and
                    prevention and advertising campaign management. Please see
                    our&nbsp;<a href="/list_partners">List of Partners</a>
                    &nbsp;for additional details about them. Generally, the data
                    collected is limited to the user&rsquo;s advertising ID,
                    device identifiers, your behavior within the Services and
                    other technical information. Such data collection practices
                    may fall under the definition of &ldquo;selling&rdquo; under
                    US Privacy Laws.
                  </li>
                  <li>
                    5.2. If you would
                    prefer that your personal information is not shared with
                    third parties in this way, please visit &ldquo;
                    <a href="/do-not-sell-my-info">
                      Do Not Sell My Personal Information
                    </a>
                    .
                  </li>
                </ol>
              </li>
              <li>
                 <strong>6. PERSONAL DATA WE COLLECTED, DISCLOSED, SHARED OR &ldquo;SOLD&rdquo;</strong>
                <ol className="awlist45">
                  <li>
                    6.1. We have&nbsp;
                    <strong>
                      <u>collected and disclosed</u>
                    </strong>
                    &nbsp;the following categories of personal information from
                    consumers of the US States within the preceding twelve (12)
                    months:
                    <ol className="awlist46">
                      <li>
                         6.1.1.
                        <strong>
                          Personal information collected and disclosed:
                        </strong>
                        <p>&nbsp;</p>
                        <table>
                          <tbody>
                          <tr>
                            <td>
                              <p>
                                <strong>Category</strong>
                              </p>
                            </td>
                            <td>
                              <p>
                                <strong>Personal information</strong>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>A. Identifiers</p>
                            </td>
                            <td>
                              <ul className="awlist47">
                                <li>
                                  <u>Name, username;</u>
                                </li>
                                <li>
                                  <u>Email address;</u>
                                </li>
                                <li>
                                  <u>Profile picture</u>{" "}
                                  (collected solely if you are linking your third-party
                                  account with the Services);
                                </li>
                                <li>
                                  <u>IP address;</u>
                                </li>
                                <li>

                                  <u>Device identifiers</u> (such as your device ID, MAC
                                  address, IMEI);
                                </li>
                                <li>

                                  <u>First-party user identifiers</u> (our own identifiers
                                  we assign to distinguish users);
                                </li>
                                <li>

                                  <u>Third-party user identifiers</u> (such as Firebase
                                  ID, Adjust ID, and other identifiers generated by a
                                  third party);
                                </li>
                                <li>

                                  <u>Advertising identifiers</u> (such as IDFA, AAID)
                                </li>
                                <li>
                                  <u>Cookies</u>
                                  &nbsp;(see our&nbsp;
                                  <a href="/cookie_policy">Cookie Policy</a>
                                  &nbsp;for more details)
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>D. Commercial information</p>
                            </td>
                            <td>
                              <ul className="awlist48">
                                <li>

                                  <u>Purchase history, transaction information:</u>
                                  &nbsp;(e.g. list of purchased items, id of operation,
                                  date, time, id, amount and currency of purchase),&nbsp;
                                  <em>
                                    <u>NOTE</u>
                                  </em>
                                  <em>:</em>{" "}
                                  <em>
                                    no sensitive financial data, like bank account and
                                    bank card details, is collected
                                  </em>
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>F. Internet or other electronic network activity</p>
                            </td>
                            <td>
                              <ul className="awlist49">
                                <li>
                                  <u>Usage data</u>: data
                                  about your use of the App (e.g. the date and time you
                                  used the App, session length, liked and saved books, App
                                  version, App install date, your interaction with other
                                  users, crash logs (errors, bugs), privacy preferences)
                                </li>
                                <li>

                                  <u>Advertising campaigns data</u>: data on the
                                  performance of our advertising campaigns displayed
                                  outside our Services (data about interaction with our
                                  advertisement (such as clicks, views, impressions,
                                  installs or other advertising campaign performance
                                  indicators)
                                </li>
                                <li>

                                  <u>Interactions with our Social Networks Pages</u>: all
                                  the details of such interaction (e.g. your communication
                                  with us via the pages, visiting pages, liking the pages
                                  / posts, forwarding them, writing messages to the posts
                                  or to us directly, referencing us)
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>G. Geolocation data</p>
                            </td>
                            <td>
                              <ul className="awlist50">
                                <li>

                                  <u>Approximate device location</u>, such as country or
                                  city-level location inferred from your IP address (
                                  <em>
                                    <u>NOTE</u>
                                  </em>
                                  <em>:</em> we do not collect precise geolocation)
                                </li>
                              </ul>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <p>&nbsp;</p>
                      </li>
                      <li>
                        6.1.2. &nbsp;
                        <strong>
                          Categories of third parties to whom personal information was
                          disclosed:
                        </strong>
                        <ul className="awlist52">
                          <li>
                            Cloud storage providers
                          </li>
                          <li>
                            Customer support providers
                          </li>
                          <li>Payment processors</li>
                          <li>Marketing partners</li>
                          <li>
                            Analytics services
                            providers
                          </li>
                          <li>Advertising networks</li>
                          <li>External auditors</li>
                          <li>
                            Regulators and public
                            authorities
                          </li>
                        </ul>
                      </li>
                      <li>
                        6.1.3.
                        <strong>
                          Business or commercial purpose for collection / disclosure:{" "}
                        </strong>
                        <ul className="awlist52">
                          <li>
                            See Clause 2.1 of the
                            Privacy Policy
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                  <li>
                    6.2. We have&nbsp;
                    <strong>
                      <u>shared or &ldquo;sold&rdquo;</u>
                    </strong>
                    &nbsp;the following categories of personal information from
                    consumers of the US States within the preceding twelve (12)
                    months:
                    <ol className="awlist54">
                      <li>
                        6.2.1. &nbsp;
                        <strong>
                          Personal information shared and &ldquo;sold&rdquo;:
                        </strong>
                        <p>&nbsp;</p>
                        <table>
                          <tbody>
                          <tr>
                            <td>
                              <p>
                                <strong>Category</strong>
                              </p>
                            </td>
                            <td>
                              <p>
                                <strong>Personal information</strong>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>A. Identifiers</p>
                            </td>
                            <td>
                              <ul className="awlist55">
                                <li>
                                  <u>IP address;</u>
                                </li>
                                <li>

                                  <u>Device identifiers</u> (such as your device ID, MAC
                                  address, IMEI);
                                </li>
                                <li>

                                  <u>First-party user identifiers</u> (our own identifiers
                                  we assign to distinguish users);
                                </li>
                                <li>

                                  <u>Third-party user identifiers</u> (such as Firebase
                                  ID, Adjust ID, and other identifiers generated by a
                                  third party);
                                </li>
                                <li>

                                  <u>Advertising identifiers</u> (such as IDFA, AAID)
                                </li>
                                <li>
                                  <u>Cookies</u>
                                  &nbsp;(see our&nbsp;
                                  <a href="/cookie_policy">Cookie Policy</a>
                                  &nbsp;for more details)
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>D. Commercial information</p>
                            </td>
                            <td>
                              <ul className="awlist56">
                                <li>

                                  <u>Purchase history, transaction information</u>
                                  &nbsp;(e.g. list of purchased items, id of operation,
                                  date, time, id, amount and currency of purchase),&nbsp;
                                  <em>
                                    <u>NOTE</u>
                                  </em>
                                  <em>:</em>{" "}
                                  <em>
                                    no sensitive financial data, like bank card details,
                                    is collected
                                  </em>
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>F. Internet or other electronic network activity</p>
                            </td>
                            <td>
                              <ul className="awlist57">
                                <li>

                                  <u>Advertising campaigns data</u>: data on the
                                  performance of our advertising campaigns displayed
                                  outside our Services (data about interaction with our
                                  advertisement (such as clicks, views, impressions,
                                  installs or other advertising campaign performance
                                  indicators)
                                </li>
                              </ul>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <p>G. Geolocation data</p>
                            </td>
                            <td>
                              <ul className="awlist58">
                                <li>

                                  <u>Approximate device location</u>, such as country or
                                  city-level location inferred from your IP address (
                                  <em>
                                    <u>NOTE</u>
                                  </em>
                                  <em>:</em> we do not collect precise geolocation)
                                </li>
                              </ul>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <p>&nbsp;</p>
                      </li>
                      <li>
                        6.2.2. &nbsp;
                        <strong>
                          Categories of third parties to whom personal information was{" "}
                        </strong>
                        <strong>shared and &ldquo;sold&rdquo;</strong>
                        <strong>:</strong>
                        <ul className="awlist52">
                          <li>Advertising networks</li>
                          <li>
                            Analytics services
                            providers
                          </li>
                        </ul>
                      </li>
                      <li>
                        6.2.3. &nbsp;
                        <strong>Business or commercial purpose for </strong>
                        <strong>sharing and &ldquo;selling&rdquo;</strong>
                        <strong>: </strong>
                        <ul className="awlist52">
                          <li>
                            Serving advertising to You
                            within the Services, both personalized (targeted) and not
                          </li>
                          <li>
                            Analysing your behaviour
                            within the Services for personalized (targeted) advertising
                          </li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                  <li>
                    6.3. We obtained
                    personal information from various sources, including but not
                    limited to:
                    <ol className="awlist54">
                      <li>
                        6.3.1. Directly from
                        you.
                      </li>
                      <li>
                        6.3.2. Directly and
                        indirectly from activity within the Services.
                      </li>
                      <li>
                        6.3.3. From third
                        parties that interact with us or you in connection with the
                        Services (e.g. payment processors, Online Stores, Sign-In
                        Tools).
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                <strong>7. DATA RETENTION &nbsp;</strong>
                <ol className="awlist45">
                  <li>
                    7.1. We retain
                    your personal information for as long as necessary to
                    provide our Services to you and fulfil the transactions you
                    have requested, or for other essential purposes such as
                    complying with our legal obligations, maintaining business
                    and financial records, resolving disputes, maintaining
                    security, detecting, and preventing fraud and abuse, and
                    enforcing our agreements. The criteria used to determine
                    retention periods includes the legal limitation of liability
                    period, agreed contractual provisions, applicable regulatory
                    requirements, and industry standards.
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
